<template>
  <div class="Profile__General__Page">
    <div class="
        Profile__General__Page__Header
        is-flex is-justify-content-space-between
      ">
      <h1>לוח שנה לקורס {{ course.name }}</h1>
      <b-button @click="addRequest" type="is-primary">הוספת אירוע</b-button>
    </div>
    <div class="Profile__General__Page__Form">
      <div class="Profile__General__Page__Form__Field">
        <b-table :data="data" :loading="isLoading" :bordered="true" :striped="true" :narrowed="false"
          :hoverable="false">
          <b-table-column centered field="Id" label="מזהה" v-slot="props">
            {{ props.row.id }}
          </b-table-column>
          <b-table-column sortable centered field="name" label="שם" v-slot="props">
            {{ props.row.name }}
          </b-table-column>
          <b-table-column sortable centered field="description" label="תיאור" v-slot="props">
            {{ props.row.description }}
          </b-table-column>
          <b-table-column sortable centered field="status" label="סטטוס" v-slot="props">
            {{ props.row.status }}
          </b-table-column>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import AdminService from '../services/AdminService';
import DialogAddExercise from "../components/DialogAddExercise.vue";
import { ModalProgrammatic as Modal } from "buefy";

export default {
  name: "AdminCourseRequests",
  data() {
    return {
      isLoading: true,
      data: [],
    };
  },
  computed: {
    course() {
      return this.$store.state.auth?.course;
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.isLoading = true;
      AdminService.getAdminCourseCalendar(this.course.id)
        .then((r) => {
          this.data = r.data;
          this.isLoading = false;
        });
    },
    addRequest() {
      Modal.open({
        component: DialogAddExercise,
        customClass: "entity-modal",
        props: {
          store: this.$store,
        },
        canCancel: false,
        trapFocus: true,
      });
    }
  },
  watch: {
    // async profileId(newValue) {
    //   if (newValue) {
    //     const users = await this.getUsers(newValue);
    //     this.users = [...users];
    //     this.isLoading = false;
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
.Profile__General__Page {
  padding: 20px 40px;

  .Profile__General__Page__Header {
    border-bottom: 1px solid silver;
    padding: 0px 10px 10px 10px;

    h1 {
      font-size: 30px;
    }
  }

  .Profile__General__Page__Form {
    margin-top: 20px;

    .Profile__General__Page__Form__Field {
      margin-top: 20px;

      .switch,
      .control {
        direction: ltr;
      }

      ::v-deep {
        .field label {
          font-size: 15px;
          color: rgb(44, 62, 80);
        }

        input {
          background-color: #f5f8fa;
          box-shadow: none;
          border: 1px solid #cbd6e2;

          &:focus {
            border: 2px solid #5fe0ea;
          }
        }
      }
    }

    .Profile__General__Page__Form__Actions {
      ::v-deep .button {
        margin-inline-end: 5px;
        background-color: #4d6884;
        color: white;
        border: none;
        border-radius: 3px;
        padding: 6px 15px;
        line-height: normal;
        height: unset;
        cursor: pointer;
        box-shadow: none;
        transition: transfrom 0.2s linear;

        &:hover {
          background-color: #54779c;
          border: none;
          outline: none;
        }

        &:active {
          transform: scale(0.98);
          border: none;
          outline: none;
        }
      }
    }
  }
}
</style>
